export const PIXEL_ID = '3070568583125644'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initPixel = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  // Avoid double initialization
  if (window.fbq) {
    window.fbq('track', 'PageView')
    return
  }

  // Initialize Facebook Pixel
  const n: any = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments)
    } else {
      n.queue.push(arguments)
    }
  }

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  window.fbq = n

  // Create and append script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Append to head safely
  const head = document.head || document.getElementsByTagName('head')[0]
  if (head) {
    head.appendChild(script)
  }

  // Initialize pixel
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export const trackEvent = (event: string, data?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, data)
  }
}
